import React from "react";
import { useField } from "formik";
import { FormControlLabel, Checkbox } from "@material-ui/core";

const MyCheckbox = ({ label, style, disabled, ...props }) => {
  const [field] = useField(props);
  return (
    <FormControlLabel
      style={{ display: "table", style }}
      control={
        <div style={{ display: "table-cell" }}>
          <Checkbox {...field} disabled={disabled} color="primary" />
        </div>
      }
      label={label}
    />
  );
};

export default MyCheckbox;
